import '../scss/styles.scss';
import { setupMobileNav } from './mobileNav';
import { setupLanguageSwitcher } from './i18n';
import { loadPublications } from './publications';
import { initScrollAnimations } from './animations';
import { setupEducationAbstracts } from './educationAbstracts';

// Set current year in the footer
document.getElementById('year').textContent = new Date().getFullYear();

// Initialize all modules
document.addEventListener('DOMContentLoaded', () => {
    setupMobileNav();
    setupLanguageSwitcher();
    loadPublications();
    setupEducationAbstracts();
    initScrollAnimations();
}); 